import type { ObservationCommentFormProps } from "./observation-comment-form.type";

import CommentForm from "@/modules/comment/comment-form";

import { useObservationCommentForm } from "./observation-comment-form.hook";

const ObservationCommentForm = ({
  observation,
  onSuccess,
  onError,
  showTitle,
  disabled,
}: ObservationCommentFormProps) => {
  const { form, onFormSubmit, isLoading } = useObservationCommentForm({
    observation,
    onSuccess,
    onError,
  });

  return (
    <CommentForm
      form={form}
      isLoading={isLoading}
      onFinish={onFormSubmit}
      showTitle={showTitle}
      disabled={disabled}
    />
  );
};

export default ObservationCommentForm;
